var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59961 15.3999V10.8666",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 11.9999V10.8666H10.8673V11.9999",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7012 14.2666H17.6678",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7012 10.8666H17.6678",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 17.6665H17.6672",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 15.3999H9.73345",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1674 7.13495C20.2728 7.24018 20.3564 7.36514 20.4134 7.50269C20.4705 7.64024 20.4998 7.78768 20.4999 7.93659V18.8006C20.4997 19.2512 20.3206 19.6833 20.002 20.002C19.6833 20.3206 19.2512 20.4997 18.8006 20.4999H5.20074C4.9775 20.5 4.75642 20.4561 4.55013 20.3708C4.34384 20.2854 4.15638 20.1603 3.99845 20.0025C3.84052 19.8447 3.71522 19.6574 3.62969 19.4511C3.54417 19.2449 3.5001 19.0239 3.5 18.8006V5.20074C3.4999 4.97737 3.54382 4.75617 3.62926 4.54978C3.71469 4.34339 3.83997 4.15586 3.99791 3.99791C4.15586 3.83997 4.34339 3.71469 4.54978 3.62926C4.75617 3.54382 4.97737 3.4999 5.20074 3.5H16.0633C16.2122 3.50003 16.3596 3.52941 16.4972 3.58645C16.6347 3.64349 16.7597 3.72708 16.8649 3.83244L20.1674 7.13495Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9668 3.5V6.89997C15.9668 7.20055 16.0862 7.48882 16.2987 7.70136C16.5113 7.91389 16.7995 8.0333 17.1001 8.0333H20.5001",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeFile);
export default __webpack_public_path__ + "static/media/office-file.f1d59ce53a6d17dd88888edccc471841.svg";
export { ForwardRef as ReactComponent };